module.exports = __webpack_public_path__ + "img/man-filled-red.d31315db.svg";